module.exports = __webpack_public_path__ + "img/icon_video_getSuccess.580e99d4.png";